import Vue from 'vue'
import Vuex from 'vuex';
// Пагинация (не используется)
// import pagination from './pagination/pagination';

// user
import user from './user'

// Страница модели (фильтрация)
import modelsFilter from './models/filter';
// Страница модели (получение данных)
import modelsFilterData from './models/filterGetData';

import modelFormLk from './models/lk/modelForm';

// Валидация телефонного номера
import errorTooltip from './errorTooltip';

// Предупреждения в логине
import loginWarning from './loginWarnings';

// Лоадер
import loader from './loader';

// Лоадер
import system from './system';

// Читальный зал
import reading_room from './reading_room/articles';

// Наши кейсы 
import cases from './cases/cases'

// Каталог плагинов
import plugins from './plugins'

// счетчики ( динамические показатели )
import counters from './counters'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // pagination,
    errorTooltip,
    modelsFilter,
    modelsFilterData,
    modelFormLk,
    loader,
    loginWarning,
    system,
    reading_room,
    cases,
    plugins,
    counters,
    user
  },
})
